import Joi from 'joi';
import { LookupListApiItem } from '../../../api/user/model';

const NumberOfDaysValidationMessage =
  'Configuration value should be larger than 0 and less than 366.';

const NumberOfTimesLoggedInValidationMessage =
  'Configuration value should be larger than 0 and less than 11.';

const NumberOfMinutesValidationMessage =
  'Configuration value should be larger than 0 and less than 31.';

const NumberOfMinutesNonPrivilegedAdminAndNonAdminValidationMessage =
  'Configuration value should be larger than 0 and less than 601.';

const NumberOfSecondsValidationMessage =
  'Configuration value should be larger than 0 and less than 3001.';

const NumberOfDaysValidation = Joi.number().integer().required().min(1).max(365).messages({
  'number.based': NumberOfDaysValidationMessage,
  'number.min': NumberOfDaysValidationMessage,
  'number.max': NumberOfDaysValidationMessage,
});

const NumberOfTimeLoggedInValidation = Joi.number().integer().required().min(1).max(10).messages({
  'number.based': NumberOfSecondsValidationMessage,
  'number.min': NumberOfTimesLoggedInValidationMessage,
  'number.max': NumberOfTimesLoggedInValidationMessage,
});

const NumberOfMinutesValidation = Joi.number().integer().required().min(1).max(30).messages({
  'number.based': NumberOfMinutesValidationMessage,
  'number.min': NumberOfMinutesValidationMessage,
  'number.max': NumberOfMinutesValidationMessage,
});

const NumberOfMinutesNonPrivilegedAdminAndNonAdminValidation = Joi.number()
  .integer()
  .required()
  .min(1)
  .max(600)
  .messages({
    'number.based': NumberOfMinutesNonPrivilegedAdminAndNonAdminValidationMessage,
    'number.min': NumberOfMinutesNonPrivilegedAdminAndNonAdminValidationMessage,
    'number.max': NumberOfMinutesNonPrivilegedAdminAndNonAdminValidationMessage,
  });

const NumberOfSecondsValidation = Joi.number().integer().required().min(1).max(3000).messages({
  'number.based': NumberOfMinutesValidationMessage,
  'number.min': NumberOfSecondsValidationMessage,
  'number.max': NumberOfSecondsValidationMessage,
});

export interface SystemSettingsConfigData {
  daysToDisableAccount: string;
  daysToLockInactivityAccount: string;
  daysToEmailAdmin: string;
  daysToInvalidateLink: string;
  timesOfMaxLogin: string;
  minutesOfSessionTimeout: string;
  minutesOfSessionTimeoutPrivilegedAdmin: string;
  minutesOfSessionTimeoutNonPriviledgeAdmin: string;
  daysOfPaymentLinkExpire: string;
  daysOfAccessLinkExpire: string;
  timesOfMaxFailedAttempt: string;
  secondToWaitLogin: string;
}

export interface SystemSettingsRequestData extends SystemSettingsConfigData {
  approver?: LookupListApiItem;
  remarks: string;
}

const schemaSystemSettings = () =>
  Joi.object<SystemSettingsRequestData>({
    daysToDisableAccount: NumberOfDaysValidation,
    daysToLockInactivityAccount: NumberOfDaysValidation,
    daysToEmailAdmin: NumberOfDaysValidation,
    daysToInvalidateLink: NumberOfDaysValidation,
    timesOfMaxLogin: NumberOfTimeLoggedInValidation,
    minutesOfSessionTimeout: NumberOfMinutesNonPrivilegedAdminAndNonAdminValidation,
    minutesOfSessionTimeoutPrivilegedAdmin: NumberOfMinutesValidation,
    minutesOfSessionTimeoutNonPriviledgeAdmin: NumberOfMinutesNonPrivilegedAdminAndNonAdminValidation,
    daysOfPaymentLinkExpire: NumberOfDaysValidation,
    daysOfAccessLinkExpire: NumberOfDaysValidation,
    timesOfMaxFailedAttempt: NumberOfTimeLoggedInValidation,
    secondToWaitLogin: NumberOfSecondsValidation,
    approver: Joi.object().messages({
      'any.required': 'Please select Approver.',
    }),
    remarks: Joi.string().required().trim().min(1).messages({}),
  });

export default schemaSystemSettings;
